import { render, staticRenderFns } from "./fileHeaderModel.vue?vue&type=template&id=398eb3f0&scoped=true&lang=pug"
import script from "./fileHeaderModel.vue?vue&type=script&lang=js"
export * from "./fileHeaderModel.vue?vue&type=script&lang=js"
import style0 from "./fileHeaderModel.vue?vue&type=style&index=0&id=398eb3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398eb3f0",
  null
  
)

export default component.exports